import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.667 29.3339H21.3337C25.1049 29.3339 26.9905 29.3339 28.1621 28.1624C29.3337 26.9908 29.3337 25.1052 29.3337 21.3339V20.0006C29.3337 16.2294 29.3337 14.3438 28.1621 13.1722C27.1376 12.1477 25.567 12.0191 22.667 12.0029M9.33366 12.0029C6.43362 12.0191 4.86308 12.1477 3.83856 13.1722C2.66699 14.3438 2.66699 16.2294 2.66699 20.0006L2.66699 21.3339C2.66699 25.1052 2.66699 26.9908 3.83856 28.1624C4.23829 28.5621 4.72115 28.8255 5.33366 28.9989",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16 2.66699L16 20.0003M16 20.0003L12 15.3337M16 20.0003L20 15.3337",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }